import { ReactNode } from 'react';
import { Card, CardMedia, CardContent, Typography, CardActionArea } from '@mui/material';

interface BaseCardProps {
  imageUrl: string;
  imageAlt: string;
  title: string;
  description?: string;
  onClick?: () => void;
  children?: ReactNode;
}

export const BaseCard = ({
  imageUrl,
  imageAlt,
  title,
  description,
  onClick,
  children,
}: BaseCardProps) => {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', width: '100%' }}>
      <CardActionArea
        onClick={onClick}
        sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
      >
        <CardMedia
          component="img"
          image={imageUrl}
          alt={imageAlt}
          sx={{
            aspectRatio: '16/9',
            objectFit: 'cover',
          }}
        />
        <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h5" component="div">
            {title}
          </Typography>
          {!!description && (
            <Typography variant="body1" sx={{ mt: 0.5, display: 'block' }}>
              {description}
            </Typography>
          )}
          {children}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
